// Triggers a browser download for an in-memory Blob or File.
// The object URL is revoked with a delay: some browsers (notably Safari)
// start reading it asynchronously after click().
const REVOKE_DELAY_MS = 40_000;

export default function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  // Must be attached to the document for the click to work in Firefox
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
}
